import React, { useEffect, useRef } from "react";
import { useAppContext } from "../../Contexts/AppContext";
import { useConvertContext } from "../../Contexts/ConvertContext";
import { replaceUrlParam } from "../utils";
import { WidgetInput } from "../Widget/WidgetInput";

export const ShareLocation = (): JSX.Element => {
    const { setShowToast } = useAppContext();
    const { coordinates } = useConvertContext();

    const shareInputRef = useRef<HTMLDivElement>();

    const params = Math.round(coordinates[0]) + "," + Math.round(coordinates[1]);
    const url = replaceUrlParam("pos", params);

    useEffect(() => {
        const element = shareInputRef.current && shareInputRef.current.getBoundingClientRect();
        if (!element) {
            return;
        }

        navigator.clipboard.writeText(url);
        setShowToast({
            position: [element.x + 80, element.y - 4],
            title: "URL nokopēts!",
            classname: "green-toast"
        });
    }, []);

    return (
        <div className="convert-share" ref={shareInputRef}>
            <WidgetInput classname={"aa"} value={url} onChange={() => console.log("do nothing")} readOnly={true} />
        </div>
    );
};
